export var BybitAccountTypeEnum;
(function (BybitAccountTypeEnum) {
    BybitAccountTypeEnum["UNIFIED"] = "UNIFIED";
    BybitAccountTypeEnum["FUND"] = "FUND";
})(BybitAccountTypeEnum || (BybitAccountTypeEnum = {}));
//# sourceMappingURL=bybit-account-type.enum.js.map